"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// this file should hold general constants which are relevant for the application
// however, no reducer specific constants should be defined here
// see https://github.com/erikras/ducks-modular-redux
// cms scope permissions are required throughout this application
// (minimal requirement for user to authenticate and authorize)
var DEFAULT_USER_AUTHORIZATION_SCOPE = exports.DEFAULT_USER_AUTHORIZATION_SCOPE = "app";
// i18n default locale
var I18N_DEFAULT_LOCALE = exports.I18N_DEFAULT_LOCALE = "de";
// misc constant exports
var DEFAULT_LIST_SORT_METHOD = exports.DEFAULT_LIST_SORT_METHOD = "ASC";
var DEFAULT_PAGINATION_LIMIT_COUNT = exports.DEFAULT_PAGINATION_LIMIT_COUNT = 20;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/constants.ts
 ** module id = 1266
 ** module chunks = 0
 **/